import type { RouteRecordRaw } from 'vue-router'

export const ExamRoutes: Array<RouteRecordRaw> = [
  {
    path: '/course_lessons',
    name: 'courses exams',
    meta: { middleware: 'auth', requiresPlanAccess: true },
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    children: [
      {
        path: ':lesson_id/exam/:exam_id',
        name: 'exam',
        props: (props) => ({
          exam_id: props.params.exam_id
        }),
        component: () => import('@/views/exam/index.vue')
      },
      {
        path: ':lesson_id/exam/:exam_id/exam-result',
        name: 'result',
        props: (props) => ({ exam_id: props.params.exam_id }),
        component: () => import('@/views/exam/exam-result.vue')
      },
      {
        path: ':lesson_id/exam/:exam_id/answer-sheet',
        name: 'answer sheet',
        props: (route) => ({ ...route.params, exam_id: route.params.exam_id }),
        component: () => import('@/views/exam/answer-sheet.vue')
      }
    ]
  }
]
